
import EditorImage from 'Editors/EditorImage'
import EditorList from 'Editors/EditorList'
import EditorTipTap from 'Editors/EditorTipTap'
import EditorLink from 'Editors/EditorLink'

// import {
//   Swiper as SwiperClass,
//   Pagination,
//   Navigation,
//   Mousewheel,
//   EffectFade,
//   Autoplay,
// } from 'swiper/core'
// SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay, EffectFade])
export default {
  components: {
    EditorList,
    // eslint-disable-next-line vue/no-unused-components
    EditorImage,
    // eslint-disable-next-line vue/no-unused-components
    EditorTipTap,
    // eslint-disable-next-line vue/no-unused-components
    EditorLink,
  },
  data() {
    return {
      swiperOptions: {
        fadeEffect: { crossFade: true },
        virtualTranslate: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        speed: 1000,
        slidersPerView: 1,
        effect: 'fade',
        slidesPerView: 1,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        breakpoints: {},
      },

      options: [
        {
          name: 'subtitle',
          label: 'Subtitle',
          type: 'tipTap',
        },
        {
          name: 'title',
          label: 'Title',
          type: 'tipTap',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'tipTap',
        },
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
        {
          name: 'background',
          label: 'background image',
          type: 'image',
        },
        {
          name: 'link',
          label: 'Poveznica',
          type: 'link',
        },
      ],
    }
  },
}
